<template>
	<a
		:class="[
			baseClass + 'action',
			disabled ? 'is-disabled' : '',
			currentPage === action.activePage && 'is-active'
		]"
		:id="uid"
		:name="uname"
		:variant="variant"
		v-if="type == 'anchor'"
		@click="action"
		v-log="loggingParams"
	>
		<span :class="baseClass + 'icon'">
			<i :class="iconClass"></i>
		</span>
		<span :class="baseClass + 'label'">{{ label }}</span>
	</a>
	<button
		:class="[baseClass + 'more', disabled ? 'is-disabled' : '']"
		:id="uid"
		:name="uname"
		:variant="variant"
		v-else-if="type == 'dropdown'"
		@click="clickMoreOptions"
		v-log="loggingParams"
	>
		<span :class="baseClass + 'icon'">
			<i :class="iconClass"></i>
		</span>
		<span :class="baseClass + 'label'">{{ label }}</span>
	</button>
	<router-link
		:class="[
			baseClass + 'action',
			disabled ? 'is-disabled' : '',
			currentPage === action.activePage && 'is-active'
		]"
		:id="uid"
		:name="uname"
		:variant="variant"
		v-bind:to="action"
		v-else
	>
		<span :class="baseClass + 'icon'" v-log="loggingParams">
			<i :class="iconClass"></i>
		</span>
		<span :class="baseClass + 'label'" v-log="loggingParams">{{
			label
		}}</span>
	</router-link>
</template>

<script>
import { LoggingMixin } from 'vue-ui-layout';

export default {
	name: 'ActionsSetAction',
	mixins: [LoggingMixin],
	props: {
		action: {
			//type: [String, Object, Function],
			default: ''
		},
		baseClass: {
			type: String,
			default: 'actions-set__'
		},
		iconClass: String,
		label: String,
		type: String,
		page: String,
		loggingParams: {
			type: Object,
			default: undefined
		}
	},
	computed: {
		currentPage() {
			return this.$store.state.currentPage;
		}
	},
	methods: {
		clickMoreOptions() {
			this.$emit('click');
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Actions Set Action - to be used in conjunction with actions-set component
    * Can use SCSS variables = TRUE
*/

.actions-set {
	&__action {
		display: block;
		padding: $padding-sm;
		min-width: 60px;
		border-bottom: 2px solid transparent;
		margin-bottom: -2px;
		cursor: pointer;

		&:focus,
		&:hover,
		&:active {
			color: $base;
			border-bottom: 2px solid $base;
			outline: 0;
		}
	}

	&__icon {
		display: block;
		font-size: $default-font-size;
	}

	&__label {
		font-size: $default-font-size - 5;
	}

	&__more {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		cursor: pointer;
		outline: 0;
		border: 0;
		display: block;
		padding: $padding-sm;
		min-width: 60px;
		height: 100%;
		background-color: $neutral-4;

		&:focus,
		&:hover,
		&:active {
			background-color: $neutral-3;
			@include text-contrast($neutral-3, $white, $black);
			border-bottom: none;
		}
	}

	&__submenu {
		display: none;
		box-shadow: 0px 2px 4px $neutral-3;
		border-radius: $card-border-radius;
		padding: $padding-xs;
		background-color: $white;
		@include text-contrast($white, $white, $black);
		position: absolute;
		right: 0;
		z-index: 1;
		text-align: left;
		overflow: hidden;
		transition-timing-function: ease-in-out;
		transition: 0.4s;

		&.is-open {
			display: block;
		}

		&-icon {
			margin-right: $gutter-md;
			vertical-align: middle;
		}

		&-label {
			vertical-align: middle;
			font-size: $default-font-size - 5;
		}
	}
}
</style>
